import apiService from "../services/apiService";

const loginObj = JSON.parse(localStorage.getItem("auth")) || {};
const defaultProductUrl = "accountingapi/default-product/";

// GET (list)
export const getDefaultProducts = async () => {
  const response = await apiService.get(
    `${defaultProductUrl}?org=${loginObj.org}`,
  );
  return response;
};

// CREATE
export const createDefaultProduct = async (payload) => {
  const response = await apiService.post(
    `${defaultProductUrl}?org=${loginObj.org}`,
    {
      ...payload,
      org: loginObj.org,
    },
  );
  return response;
};

// UPDATE (PATCH)
export const updateDefaultProduct = async (id, payload) => {
  const response = await apiService.patch(
    `${defaultProductUrl}${id}/?org=${loginObj.org}`,
    {
      ...payload,
      org: loginObj.org,
    },
  );
  return response;
};

// DELETE (optional but recommended)
export const deleteDefaultProduct = async (id) => {
  const response = await apiService.delete(
    `${defaultProductUrl}${id}/?org=${loginObj.org}`,
  );
  return response;
};
